import React, {Component} from 'react'
import i18next from 'i18next';

import Chapter from './Chapter'
import {ChevronLeft, ChevronRight} from 'react-feather'
import styled from '@emotion/styled'
import sv from '../../../../styles/styles'
import {isMobile} from 'react-device-detect';
import SwipeableViews from 'react-swipeable-views';
import noSpeechIcon from "../../../../images/no-speech.svg"
import {connect} from "react-redux";
import {playerActions} from "../../../../_actions/player.actions";
import {cloudRefiner} from "../../../../defaults/cloudMaker";
import {isNarrow} from "./GridGistItem";

// size of the paging button, in pixels
const PAGING_BUTTON_SIZE = 50;

// STYLE ##########################################################

const Container = styled('div')`
  height: ${props => props.sliderHeight}px;
  width: 100%;
  max-width: 1100px;
  position: relative;
  .react-swipeable-view-container {
    height: 100%;
  }
  box-shadow: 0 -2px 3px rgba(0,0,0,0.3);
  order: 1;
`;

const ButtonContainer = styled(`div`)`
  position: absolute;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  left: ${props => props.next ? '' : '0px'};
  right: ${props => props.next ? '0px' : ''};
  top: ${props => props.isNarrow ? "inherit" : "50%"};
  margin-top: -${props => props.size/2 - 15}px;
  ${sv.box};
  z-index: ${props => props.zIndex};
`;

const ChapterButton = styled(`div`)`
  transition: background .2s ease-out;
  cursor: pointer;
  height: 100%;
  width: 100%;
  ${sv.flexCenter};
  background: rgba(244,173,70, 0);
  border-radius: 6px;
  -webkit-tap-highlight-color: rgba(244,173,70, .3);
  &:hover {
    background: ${props => props.isMobile ? "rgba(244,173,70, 0)" : "rgba(244,173,70, .3)"};
  }
`;

const NoSpeechImage = styled('img')`
  opacity: .50;
  padding: 0 7px 0 0;
`;

const NoSpeechMessageContainer = styled(`div`)`
  color: ${sv.colors.subtleLight};
  ${sv.flexCenter};
  height: 100%;
  visibility: ${props => props.isCurrent ? 'visible' : 'hidden'};
`;

// COMPONENT ##########################################################

// invokers for chapter navigation
const ChapterSliderType = {
	CHAPTER_SLIDER  : "CHAPTER_SLIDER",
	CHAPTER_NAV     : "CHAPTER_NAV",
};

class CloudSlider extends Component {

  state = {
    chapterWidth: 0,
    chapterHeight: 0,
    pagingButtonSize: 50,
    index: 0,
    buttonZIndex: 1100,
    gistLocked: false
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateChapterSize);
    this.updateChapterSize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateChapterSize);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const cloudChanged = prevProps.clouds !== this.props.clouds;
    const sizeChanged = prevProps.containerW !== this.props.containerW || prevProps.containerH !== this.props.containerH;
    const pagingButtonSizeChanged = prevState.pagingButtonSize !== this.state.pagingButtonSize;

    if (cloudChanged || sizeChanged || pagingButtonSizeChanged) this.updateChapterSize();
    if (this.props.currentChapter-1 !== this.state.index) this.setState({index: this.props.currentChapter-1})
  }

  updateChapterSize = () => {
    let chapterWidth = this.getChapterWidth();
    this.setState({
      pagingButtonSize: PAGING_BUTTON_SIZE,
      chapterWidth: chapterWidth,
      chapterHeight: this.getChapterHeight()
    })
  };

  getChapterWidth = () => {
    return this.container.offsetWidth;
  };

  getChapterHeight = () => {
    let sliderHeight;
    if (this.props.isVideo) {
      sliderHeight = 200;
    } else {
      sliderHeight = 0.75 * this.props.containerH;
    }
    return sliderHeight;
  };

  nextChapter = () => {
	  this.props.updateCurrentChapter(this.props.currentChapter+1);
	  this.props.dispatchChapterChange(ChapterSliderType.CHAPTER_NAV);
  };

  prevChapter = () => {
	  this.props.updateCurrentChapter(this.props.currentChapter-1);
	  this.props.dispatchChapterChange(ChapterSliderType.CHAPTER_NAV);
  };

  indexChanged = (index) => {
	  if (index !== this.state.index) this.props.updateCurrentChapter(index+1);
	  this.props.dispatchChapterChange(ChapterSliderType.CHAPTER_SLIDER);
  };

  onHintTextShown = (isShown) => {
    this.setState({ buttonZIndex: isShown ? 900 : 1100});
  };

  setLockGist = (lock) => {
    const {gistLocked} = this.state;

    if (gistLocked !== lock) {
      this.props.setEnableHideGist(!lock);
      this.setState({gistLocked: lock});
    }
  };

  /// RENDER ###################################################################

  render() {
    const {currentChapter, clouds} = this.props;
    const t = i18next.t;

    const showPrevChapterButton = currentChapter > 1;
    const showNextChapterButton = currentChapter < clouds.length;

    let narrow = isNarrow(this.state.chapterWidth);

    // Build a set of "nextClouds" just to tier and select the next cloud element for each cloud
    let nextClouds = clouds.map((cloud) => cloudRefiner(cloud, narrow ? 9 : 15, 3)[0]);

    let sliderHeight = narrow ? "calc(100% - " + (PAGING_BUTTON_SIZE - 30) + "px)" : "100%";

    return (
      <Container
        className="scontainer"
        ref={node => this.container = node}
        sliderHeight={this.state.chapterHeight}
      >
        <SwipeableViews
          style={{padding: '0', boxSizing: 'border-box', height: sliderHeight, overflow: 'visible', overflowX: 'visible', zIndex: 1000, position: 'relative'}}
          slideStyle={{overflow: 'visible', overflowX: 'visible', overflowY: 'visible'}}
          enableMouseEvents
          ignoreNativeScroll
          index={this.state.index}
          onChangeIndex={(index) => this.indexChanged(index)}
          disabled={this.state.gistLocked}
        >
          {clouds.length > 0 &&
            clouds.map((chapter, index) => {
              const isCurrentChapter = this.props.currentChapter === index + 1;
              // if contents, populate else no-content message
              if (chapter.length > 0) {
                return (
                    <Chapter
                        key={index}
                        playWord={this.props.playWord}
                        cloud={chapter}
                        nextElement={index < nextClouds.length - 1 ? nextClouds[index+1] : null}
                        chapterNumber={index + 1}
                        chapterWidth={this.state.chapterWidth}
                        chapterHeight={this.state.chapterHeight}
                        showWordOnTimeline={this.props.showWordOnTimeline}
                        hideWordOnTimeline={this.props.hideWordOnTimeline}
                        isCurrentChapter={isCurrentChapter}
                        onHintTextShown={this.onHintTextShown}
                        getGistPlayerRect={this.props.getGistPlayerRect}
                        setLockGist={this.setLockGist}
                    />
                )
              } else {
                return (
                    <NoSpeechMessageContainer isCurrent={isCurrentChapter} key={index} >
                      <NoSpeechImage src={noSpeechIcon} alt="no-speech"/>
                      {t("no discernible speech")}
                    </NoSpeechMessageContainer>
                );
              }
            })
          }
        </SwipeableViews>

        {showPrevChapterButton &&
          <ButtonContainer
            onClick={() => this.prevChapter()}
            size={this.state.pagingButtonSize}
            zIndex={this.state.buttonZIndex}
            isNarrow={narrow}
          >
            <ChapterButton isMobile={isMobile}><ChevronLeft size={28} color={sv.colors.cta} /></ChapterButton>
          </ButtonContainer>
        }

        {showNextChapterButton &&
          <ButtonContainer
            onClick={() => this.nextChapter()}
            next
            size={this.state.pagingButtonSize}
            zIndex={this.state.buttonZIndex}
            isNarrow={narrow}
          >
            <ChapterButton next isMobile={isMobile}><ChevronRight size={28} color={sv.colors.cta} /></ChapterButton>
          </ButtonContainer>
        }
      </Container>
    )
  }
}

function mapStateToProps() {
	return {}
}

function mapDispatchToProps(dispatch) {
	return {
		dispatchChapterChange     : (type)    => dispatch( playerActions.onChapterChange(type) ),
	}
}

const connectedCloudSlider = connect(mapStateToProps, mapDispatchToProps)(CloudSlider);
export default connectedCloudSlider;
